angular.module('app.serviceBreakerService', [])
  .factory('app.serviceBreakerService', [
    '$http',
    function ($http) {
      'use strict';

      let service = {
        breakers: {},
        retrieveByGroup: (group) => {
          return $http.get(window.location.api('/service_breakers/groups/' + group));
        },
        checkRecurly: () => {
          return service.retrieveByGroup('recurly')
            .then(response => {
              let data = response.data;

              if (Array.isArray(data) && data.length) {
                service.breakers.recurly = data[0];
              }

              return response;
            });
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/serviceBreakerService.js